import axios from 'axios';

const api = axios.create({
    baseURL: 'https://ticket.wageh.net/api/api', // الرابط الجديد بتاع الباك إند
    headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
    },
    withCredentials: true
});

// الأداة دي (Interceptor) بتلقط أي ريكويست طالع من React وتحط فيه التوكن
api.interceptors.request.use(
    (config) => {
        const token = localStorage.getItem('token');
        if (token) {
            config.headers.Authorization = `Bearer ${token}`;
        }
        return config;
    },
    (error) => {
        return Promise.reject(error);
    }
);

// تصدير واحد بس في آخر الملف زي ما الكتاب بيقول
export default api;